window.$ = window.jQuery;

import "./vendors/numslider";
import "./vendors/serializeObject";

//Globals scripts
import "./globals";

// Search
import "./search";

// Globals
import "../../partials/components/globals";

// Inputs
import "../../partials/components/inputs";

// Forms
import "../../partials/components/forms";

// Sliders
import "../../partials/components/sliders";
// Accordions
import "../../partials/components/accordions";
// Maps
// import "../../partials/components/maps";
// Timeline
// import "../../partials/components/timelines";
// Video
import "../../partials/components/videos";
// Blocks
import "../../partials/components/blocks";
// Gallery
import "../../partials/components/galleries";
// Popups
import "../../partials/components/popups";

// heads
// import "../../partials/components/heads";

// Lazy
// import "../js/lazy/Paroller/paroller";
import "../js/lazy/LoadAnimate/load-animate";

$(".form-toggle__form").hide();
$(".form-toggle__button").click(function(e) {
  e.preventDefault();
  $(this)
    .closest(".form-toggle")
    .find(".form-toggle__form")
    .slideToggle();
});

// Select all links with hashes
$('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();

        window.scrollTo({
          top: target.offset().top - 100,
          behavior: "smooth",
        });
      }
    }
  });

// import Rellax from "rellax";

// var rellax = new Rellax(".rellax", {
//   center: true,
// });
// var rellaxShop = new Rellax(".rellax-shop", {
//   center: false,
// });

// window.onload = function() {
//   jQuery(".presentation-category__img-wrapper").addClass("loaded");
//   rellax.refresh();
//   rellaxShop.refresh();
// };

// let parent = document.querySelector('.sticky').parentElement;

// while (parent) {
//     const hasOverflow = getComputedStyle(parent).overflow;
//     if (hasOverflow !== 'visible') {
//         console.log(hasOverflow, parent);
//     }
//     parent = parent.parentElement;
// }
